import {
  Button,
  Heading,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  SimpleGrid
} from '@chakra-ui/react';
import React,{ useCallback } from 'react';
import TicTacToeGame from '../../classes/TicTacToeGame';
import useCoveyAppState from '../../hooks/useCoveyAppState';
import useMaybeVideo from '../../hooks/useMaybeVideo';
import usePlayersInTown from '../../hooks/usePlayersInTown';

type TicTacToeGamePlayModalProps = {
  isOpen: boolean;
  closeModal: ()=>void;
  newTicTacToeGame: TicTacToeGame;
}

/**
 * Modal that handles game play between the two players of a given TicTacToeGame
 * @param param0 TicTacToeGamePlayModalProps to hand in to modal
 * @returns 
 */
export default function TicTacToeGamePlayModal( {isOpen, closeModal, newTicTacToeGame} : TicTacToeGamePlayModalProps): JSX.Element {
  const {socket, myPlayerID} = useCoveyAppState();

  const {board, turn, id}= newTicTacToeGame;

  const video = useMaybeVideo()

  const playersInTown = usePlayersInTown();
  const playerX = playersInTown.find(player => player.id === newTicTacToeGame.players.playerX);
  const playerO = playersInTown.find(player => player.id === newTicTacToeGame.players.playerO);

  const playMove = useCallback(async (pos: BoardPosition) => {
    if (myPlayerID === playerO?.id || myPlayerID === playerX?.id) {
      if (myPlayerID === playerO?.id && turn === "O") {
        if (socket) {
          socket.emit('onPlayerMove', id, myPlayerID, pos[0], pos[1])
        }
      } else if (myPlayerID === playerX?.id && turn === "X") {
        if (socket) {
          socket.emit('onPlayerMove', id, myPlayerID, pos[0], pos[1])
        }
      }
    }
  }, [id, myPlayerID, playerO?.id, playerX?.id, socket, turn]);

  let headerText;
  if (myPlayerID === playerX?.id && !playerO) {
    headerText = 'You are player X!\nWaiting for another player.';
  } else if (myPlayerID === playerX?.id) {
    headerText = `You are player X!\nPlaying against ${  playerO?.userName}.`;
  } else if (myPlayerID === playerO?.id) {
    headerText = `You are player O!\nPlaying against ${  playerX?.userName}.`;
  } else if (newTicTacToeGame.occupantsByID.includes(myPlayerID)) {
    headerText = `Watching game between ${  playerX?.userName  } and ${   playerO?.userName}`;
  }

  return (
    <Modal size='xl' isOpen={isOpen} onClose={()=>{closeModal(); video?.unPauseGame()}}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{headerText}</ModalHeader>
        <ModalCloseButton />
          <ModalBody pb={5}>
            <Heading fontSize='xl' as='h1'>It is {newTicTacToeGame.turn}{'\''}s turn!</Heading>
            <SimpleGrid columns={3} spacing={1}>
              <Button height="175px" width="175px" border="4px" borderColor="black" fontSize='150px' fontWeight='semibold'
              onClick={() => playMove([0,0])}>{board[0][0]}</Button>
              <Button height="175px" width="175px" border="4px" borderColor="black" fontSize='150px' fontWeight='semibold'
              onClick={() => playMove([0,1])}>{board[0][1]}</Button>
              <Button height="175px" width="175px" border="4px" borderColor="black" fontSize='150px' fontWeight='semibold'
              onClick={() => playMove([0,2])}>{board[0][2]}</Button>
              <Button height="175px" width="175px" border="4px" borderColor="black" fontSize='150px' fontWeight='semibold' 
              onClick={() => playMove([1,0])}>{board[1][0]}</Button>
              <Button height="175px" width="175px" border="4px" borderColor="black" fontSize='150px' fontWeight='semibold' 
              onClick={() => playMove([1,1])}>{board[1][1]}</Button>
              <Button height="175px" width="175px" border="4px" borderColor="black" fontSize='150px' fontWeight='semibold' 
              onClick={() => playMove([1,2])}>{board[1][2]}</Button>
              <Button height="175px" width="175px" border="4px" borderColor="black" fontSize='150px' fontWeight='semibold' 
              onClick={() => playMove([2,0])}>{board[2][0]}</Button>
              <Button height="175px" width="175px" border="4px" borderColor="black" fontSize='150px' fontWeight='semibold' 
              onClick={() => playMove([2,1])}>{board[2][1]}</Button>
              <Button height="175px" width="175px" border="4px" borderColor="black" fontSize='150px' fontWeight='semibold' 
              onClick={() => playMove([2,2])}>{board[2][2]}</Button>
            </SimpleGrid>
          </ModalBody>
      </ModalContent>
    </Modal>
  );
}

type BoardPosition = [0,0] | [0,1] | [0,2] | [1,0] | [1,1] | [1,2] | [2,0] | [2,1] | [2,2];